import { useEffect } from "react";
import { initCA } from "@vp/chat-anywhere";
import { initChatbot } from "@vp/chatbot-ui";
import { initialize, isFeatureEnabled, whenAvailable } from "@vp/ab-reader";
import { useTracking } from "../components/root/contexts/TrackingContext";
import { getCulture } from "../utils/LocalizationHelpers";

export const useChatAnywhere = (): void => {
    const culture = getCulture();
    const { getTrackingConfiguration } = useTracking();

    useEffect(() => {
        try {
            initialize();
            whenAvailable((available) => {
                if (available && isFeatureEnabled('ca-chatbot-ubik')) {
                    initChatbot({ locale: culture?.toLowerCase(), pageName: getTrackingConfiguration().pageName });
                } else {
                    initCA();
                }
            }, 1000);
        } catch (error) {
            console.error(`Chat anywhere package could not be loaded`, error);
        }
    }, [culture, getTrackingConfiguration]);
};
